export default {
  methods: {
    showAdvertisingBannerDetail(id) {
      if (this.$_loggedUser_action_allowed('advertisingBanners', 'read')) {
        this.$router.push({ name: 'advertisingBannerDetail', params: { id } })
      }
    },
    showBrandDetail(id) {
      if (this.$_loggedUser_action_allowed('brands', 'read')) {
        this.$router.push({ name: 'brandDetail', params: { id } })
      }
    },
    showBusinessModelDetail(id) {
      if (this.$_loggedUser_action_allowed('businessModels', 'read')) {
        this.$router.push({ name: 'businessModelsDetail', params: { id } })
      }
    },
    showChannelDetail(id) {
      if (this.$_loggedUser_action_allowed('channels', 'read')) {
        this.$router.push({ name: 'channelDetail', params: { id } });
      }
    },
    showChannelPackageDetail(id) {
      if (this.$_loggedUser_action_allowed('packages', 'read')) {
        this.$router.push({ name: 'packageDetail', params: { id } });
      }
    },
    showDeviceDetail(id) {
      if (this.$_loggedUser_action_allowed('devices', 'read')) {
        this.$router.push({ name: 'deviceDetail', params: { id } })
      }
    },
    showDeviceChannelGroupDetail(idDevice, idGroup) {
      if (this.$_loggedUser_action_allowed('channelGroups', 'read')) {
        this.$router.push({ name: 'deviceChannelGroup', params: { idDevice, idGroup } })
      }
    },
    showDeviceProfileDetail(id) {
      if (this.$_loggedUser_action_allowed('deviceProfiles', 'read')) {
        this.$router.push({ name: 'deviceProfileDetailProperties', params: { id } })
      }
    },
    showDeviceTypeDetail(id) {
      if (this.$_loggedUser_action_allowed('deviceTypes', 'read')) {
        this.$router.push({ name: 'deviceTypeDetailDescription', params: { id } })
      }
    },
    showMessageDetail(id) {
      if (this.$_loggedUser_action_allowed('messages', 'read')) {
        this.$router.push({ name: 'messageDetail', params: { id } })
      }
    },
    showOperatorDetail(id) {
      if (this.$_loggedUser_action_allowed('operators', 'read')) {
        this.$router.push({ name: 'operatorDetail', params: { id } })
      }
    },
    showProtocolDetail(id) {
      if (this.$_loggedUser_action_allowed('protocols', 'read')) {
        this.$router.push({ name: 'protocolDetail', params: { id } })
      }
    },
    showServiceDetail(id) {
      if (this.$_loggedUser_action_allowed('services', 'read')) {
        this.$router.push({ name: 'serviceDetail', params: { id } })
      }
    },
    showSubscriberDetail(id) {
      if (this.$_loggedUser_action_allowed('subscribers', 'read')) {
        this.$router.push({ name: 'subscriberDetail', params: { id } })
      }
    },
    showSubscriberProfileDetail(id) {
      if (this.$_loggedUser_action_allowed('subscribers', 'read')) {
        this.$router.push({ name: 'subscriberProfileDetail', params: { id } });
      }
    },
    showSubscriberChannelGroupDetail(idGroup) {
      if (this.$_loggedUser_action_allowed('channelGroups', 'read')) {
        this.$router.push({ name: 'subscriberChannelGroup', params: { idGroup } });
      }
    },
    showSubscriberDevicesDetail(id) {
      if (this.$_loggedUser_action_allowed('subscribers', 'read')) {
        this.$router.push({ name: 'subscriberDetailDevices', params: { id } })
      }
    },
    showThematicGroupDetail(id) {
      if (this.$_loggedUser_action_allowed('thematicGroups', 'read')) {
        this.$router.push({ name: 'thematicGroupDetail', params: { id } })
      }
    },
    showVodProviderDetail(id) {
      if (this.$_loggedUser_action_allowed('vod', 'read')) {
        this.$router.push({ name: 'vodProvidersSettings', params: { id } })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/links.js